// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const carRoutes = [
  route('create', '/create', Create, meta('Adicionar novo Veículo', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Veículo', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Veículos', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/car', carRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/car/routes.js